<template>
  <div class="changeNameDialog">
    <Modal
      v-model="isOpen"
      width="800"
      :footer-hide="true"
    >
      <div class="changeWarpper">
        <p class="title">
          设置会员卡
        </p>
        <Table :columns="cardCols" :data="vipProjects">
          <template slot="checkRadio" slot-scope="{ row }">
            <div class="vip-radio">
              <p>
                <input :id="row.project_id" v-model="passportProjectId" type="radio" :value="row.project_id">
                <label :for="row.project_id" style="display: none"> {{ row.project_id }}</label>
              </p>
            </div>
          </template>
          <template slot="project_id" slot-scope="{ row }">
            <div class="price">
              <p>{{ row.project_id }}</p>
            </div>
          </template>
          <template slot="project_name" slot-scope="{ row }">
            <div class="price">
              <p>{{ row.project_name }}</p>
            </div>
          </template>
          <template slot="project_artist" slot-scope="{ row }">
            <div class="price">
              <p class="price">
                {{ row.project_artist }}
              </p>
            </div>
          </template>
          <template slot="project_artist_address" slot-scope="{ row }">
            <p class="price">
              {{ getShortAddress(row.project_artist_address) }}
            </p>
          </template>
        </Table>
        <div class="button-warpper">
          <button @click="onSave">
            Save
          </button>
          <button style="margin-left: 20px" @click="onCancel">
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isOpen: false,
        passportProjectId: 0,
        newName: "",
        rowData: {},
        vipProjects: [],
      };
    },
    computed: {
      cardCols() {
        return [{
          title: '单选',
          slot: "checkRadio",
          width: 80,
        },{
          title: 'ID',
          slot: "project_id",
        },{
          title: 'Card Name',
          slot: "project_name",
        },{
          title: 'Artist',
          slot: "project_artist",
        },{
          title: 'Address',
          slot: "project_artist_address",
        },];
      }
    },
    methods: {
      async open(rowData, vipProjects) {
        this.isOpen = true;
        this.rowData = rowData;
        this.vipProjects = vipProjects;
      },
      async onSave() {
        const res = await this.$parent.onBindProjectToVip({
          projectId: this.rowData.project_id,
          passportProjectId: this.passportProjectId,
        });
        this.isOpen = false;
      },
      onCancel() {
        this.isOpen = false;
      },
      getShortAddress(address) {
        return `${address.slice(0, 6)}...${address.slice(-6)}`;
      },
    },
  };
</script>

<style lang="less" scoped>
    .title {
        width: 100%;
        text-align: center;
        font-size: 24px;
        color: #fff;
        margin: 20px 0px;
    }
    .button-warpper {
      margin: 40px 0px;
      text-align: center;
      button {
        width: 120px;
        padding: 6px 12px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        border-radius: 5px;
        outline: none;
        background-image: linear-gradient(45deg, #8baaaa 0%, #ae8b9c 100%);
        &:hover {
          background-image: linear-gradient(45deg, #ae8b9c 0%, #8baaaa 100%);
        }
      }
    }
</style>
